module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }